/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import type { TGetState } from '../../../core/tivo/tivo-redux-wrapper';
import {
    onLeftSetPreviousPage,
    onRightGuideOperations,
    turnOnPastGuideMode,
} from '../guide.reducers';
import { setHorizontalPositionAction } from '../guidehighlight/guidehighlight.actions';
import {
    setHorizontalPageCount,
    setHorizontalPosition,
} from '../guidehighlight/guidehighlight.reducers';

export const onRightMainGuideOperations = () => (dispatch: Function) => {
    dispatch(onRightGuideOperations());
};

export const onLeftMainGuideOperations = () => (dispatch: Function, getState: TGetState) => {
    const { guideHighlight, gridGuide } = getState();
    const { guideRows, pastGuideRows } = gridGuide;
    const { horizontalPosition, horizontalPageCount, verticalPosition } = guideHighlight;

    if (horizontalPosition === 0 && horizontalPageCount === 0) {
        dispatch(turnOnPastGuideMode());
        dispatch(onLeftSetPreviousPage());
        dispatch(setHorizontalPageCount(horizontalPageCount - 1));
        return;
    }

    const hasValidPastGuideRows = pastGuideRows && pastGuideRows.length > 0;
    if (hasValidPastGuideRows) {
        if (horizontalPosition > 0 && horizontalPageCount >= 0)
            dispatch(setHorizontalPosition(horizontalPosition - 1));
    }

    if (
        guideRows &&
        guideRows.length > 0 &&
        horizontalPageCount > 0 &&
        pastGuideRows[verticalPosition]
    ) {
        const { guideCells } = guideRows[verticalPosition];
        const { guideCells: pastGuideCells } = pastGuideRows[verticalPosition];
        // moving left from leftmost cell
        const leftOfCurrentCell = guideCells && guideCells[horizontalPosition - 2];
        const previousPageLastCell = pastGuideCells && pastGuideCells.length;
        if (!leftOfCurrentCell) {
            dispatch(onLeftSetPreviousPage());
            dispatch(setHorizontalPosition(previousPageLastCell));
        }
    }

    if (guideRows && !guideRows[verticalPosition]) {
        dispatch(setHorizontalPositionAction(0));
    }
};
